import React from 'react'
import Dialog from './../../../modules/Dialog'
import BranchSave from './BranchSave'

export default props => <Dialog>
  <BranchSave {...props} />
</Dialog>


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/SaveBranchDialog/SaveBranchDialog.js